// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__NoKcw","select":"Header_select__3Znkt","clinic":"Header_clinic__3p-tk"};